export default __webpack_public_path__ + "static/media/Hoops Simplified Import Template.33b910eb.csv";